<template>
  <div>
    <section class="overlay" v-if="errored">
      <p class="overlay-text">申し訳ありませんが、<br />現時点ではこの情報を取得できません。<br />しばらくしてからもう一度お試しください</p>
    </section>

    <section v-else>
      <div class="overlay" v-if="loading">
        <p class="overlay-text loading-text">Loading...</p>
        <div class="loading-spacer">
          <vue-loading type="spiningDubbles" color="#FFF" :size="{ width: '100px', height: '100px' }"></vue-loading>
        </div>
      </div>
      <Header />
      <div class="food-type">
        <p v-if="page === 0">主食</p>
        <p v-else-if="page < 11">副食</p>
        <p v-else>水分量</p>
      </div>

      <div class="panel-body" v-show="!loading">
        <div class="meals" v-if="page < 11">
          <div class="img-bg">
            <img v-bind:src="q.img" width="2260" height="3116" loding="lazy" />
          </div>
          <br />
          <div class="answer">
            <img class="yes" src="@/assets/meal_entry/アセット 1@2x.png" @click="answer(true)" width="905" height="336" loding="lazy" />
            <img class="no" src="@/assets/meal_entry/アセット 2@2x.png" @click="answer(false)" width="905" height="336" loding="lazy" />
          </div>
        </div>
        <InputWaterIntake v-if="page === 11" @handle-change-water="changeWater" @handle-complete="pushedDone" :ingestedWaterAmount="ingestedWaterAmount"/>
      </div>

      <div class="back">
        <img src="@/assets/meal_entry/アセット 3@2x.png" class="go-back-one" v-if="0 < page" @click="backOne" width="884" height="336" loding="lazy" />
        <router-link to="/home">
          <img src="@/assets/meal_entry/アセット 4@2x.png" class="go-home" width="884" height="336" loding="lazy" />
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import moment from "moment";
import Header from "@/components/Header";
import InputWaterIntake from "@/molecules/InputWaterIntake";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { VueLoading } from 'vue-loading-template';
const FoodsRepository = RepositoryFactory.get("foods");
const UserRepository = RepositoryFactory.get("user");
export default {
  name: "RecordMeals",
  components: {
    Header,
    InputWaterIntake,
    VueLoading,
  },
  beforeDestroy() {
    document.body.className = "";
  },
  data() {
    return {
      itemList: [],
      mealslist: [{ img: "" }, { img: "" }, { img: "" }, { img: "" }, { img: "" }, { img: "" }, { img: "" }, { img: "" }, { img: "" }, { img: "" }, { img: "" }],
      page: 0,
      show: false,
      water: 0,
      answers: [],
      loading: true,
      errored: false,
      sideDish: [],
      stapleFood: [],
      today: moment().format("YYYY-MM-DD"),
      checkFoodsIngestedToday: [],
      ingestedWaterAmount: 0
    };
  },
  created() {
    this.RefreshTokenUpdate()
  },
  async mounted() {
    document.body.className = "back-color";

    const part = "standard";
    const healthDevStorage = "https://healthdevstorage.blob.core.windows.net/health/";
    await FoodsRepository.get(part, this.$store.state.axiosHeaders)
      .then((response) => (this.itemList = response.data))
      .catch((error) => {
        console.log(error);
        this.errored = true;
      });
    const itemCount = Object.keys(this.itemList);
    const len = itemCount.length;
    for (let i = 0; i < len; i++) {
      this.mealslist[i].img = healthDevStorage + this.itemList[i].img_path;
      if (this.itemList[i].type === 0) {
        this.stapleFood.push(String(this.itemList[i].id));
      } else {
        this.sideDish.push(String(this.itemList[i].id));
      }
    }
    // 今日の食事記録を取得する
    this.foodsIngestedPeriodApi()
  },
  methods: {
    async RefreshTokenUpdate(){
      this.$store.state.axiosHeaders.access_token_expires_in = 1614566933; //有効期限切れトークン　検証時にコメントアウト外す
      // users.access_token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJsYXNoaWMiLCJleHAiOjE2NDA4NzY0MDAsInVzZXJfaWQiOiI3Nzc3In0.vzDNjvjXiM8f41xSU48-zI7VYEPXPbOpVlENvuHaWgg"
      let access_token_expires_in = new Date(this.$store.state.axiosHeaders.access_token_expires_in * 1000);
      let now = new Date();

      if (now > access_token_expires_in) {
        const UserEndpoint = "token/refresh";
        const body = {
          refresh_token: this.$store.state.axiosHeaders.refresh_token,
        };
        const config = {
          withCredentials: true,
        };
        await UserRepository.put(UserEndpoint, body, {config})
        .then(response => (this.res = response.data))
        .catch((error) => console.log(error))
        .finally(() => {
          const headers = {
            Authorization: "Bearer " + this.res.access_token,
            "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
            access_token_expires_in: this.res.access_token_expires_in,
            refresh_token: this.res.refresh_token
            }
            this.$store.commit("FETCH_ADD_AXIOS_HEADERS", headers);
        })
      }
    },
    answer: function(value) {
      this.answers.push(value);
      this.page++;
      if(Object.keys(this.checkFoodsIngestedToday).length != 0) {
      const nowPage = this.page +1
      for(let i = nowPage; i < 12; i++) {
        if (!this.checkFoodsIngestedToday[0].side_dish[i]) {
          return []
        }
        this.answers.push(true);
        this.page++;
      }
      }
    },
    backOne() {
      this.answers.pop();
      this.page--;
    },
    async pushedDone() {
      this.loading = true
      const body = {
        staple_food: { [this.stapleFood[0]]: this.answers[0] },
        side_dish: {},
        water: this.water,
        number_recorded: 1,
        date: this.today,
      };
      const len = this.sideDish.length;

      for (let i = 0; i < len; i++) {
        this.$set(body.side_dish, this.sideDish[i], this.answers[i+1]);
      }

      if (Object.keys(this.$store.state.foodsIngestedToday).length != 0) {
        console.log("put処理")
        const part = "ingested/" + this.today;
        await FoodsRepository.put(part, body, this.$store.state.axiosHeaders)
          .then((response) => console.log("put処理成功"))
          .catch((error) => console.log(error));
        this.$router.push({name: 'History', params: {propsSelected: true}});
      } else {
        console.log("post処理")
        const part = "ingested";
        await FoodsRepository.post(part, body, this.$store.state.axiosHeaders)
          .then((response) => console.log("post処理成功"))
          .catch((error) => console.log(error));
        this.$router.push({name: 'History', params: {propsSelected: true}});
      }
    },
    changeWater(value) {
      this.water = value;
    },
    async foodsIngestedPeriodApi() {
      const today = moment().format("YYYY-MM-DD");
      const foodsEndpoint = "ingested/period?from=" + today + "&to=" + today;
      await FoodsRepository.getFromTo(foodsEndpoint, this.$store.state.axiosHeaders)
        .then((response) => (this.checkFoodsIngestedToday = response.data))
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        if(Object.keys(this.checkFoodsIngestedToday).length != 0) this.whetherIngestedToday()
        this.loading = false
    },
    whetherIngestedToday() {
      this.ingestedWaterAmount = this.checkFoodsIngestedToday[0].water
      this.water = this.checkFoodsIngestedToday[0].water
      if(this.checkFoodsIngestedToday[0].staple_food[1]) {
        this.answers.push(true);
        this.page++;
      }
      for (const items in this.checkFoodsIngestedToday[0].side_dish) {
        if (!this.checkFoodsIngestedToday[0].side_dish[items]) {
          return []
        }
        this.answers.push(true);
        this.page++;
      }
    }
  },
  computed: {
    q: function() {
      return this.mealslist[this.page % this.mealslist.length];
    },
  },
};
</script>

<style scoped>
/* @import "../assets/css/record_meals.css"; */
.overlay {
    /*要素を重ねた時の順番*/
    z-index: 10;
    /*画面全体を覆う設定*/
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
  }
  .overlay p {
    color: white;
    font-size: 1.2rem;
  }
  p.overlay-text {
    color: white;
    font-size: 1.2rem;
  }
  p.loading-text {
    font-size: 2rem;
  }
  .food-type {
    display: inline-block;
    margin-top: 10%;
  }
  
  .food-type p {
    font-size: 1.8rem;
    color: #00a0b9;
    font-weight: bold;
    margin: 0;
  }
  .panel-body {
    position: relative;
  }
  .img-bg img {
    width: 95%;
  }
  .answer img {
    width: 35%;
    position: absolute;
    bottom: 15%;
  }
  .answer .yes {
    left: 13%;
  }
  .answer .no {
    right: 13%;
  }
  .back {
    position: absolute;
    bottom: 7%;
  }
  .back img {
    width: 35%;
  }
  .go-back-one {
    margin-right: 2%;
  }
  .go-home {
    margin-left: 2%;
  }
  
  @media screen and (max-width:375px) and (max-height: 667px) { 
    .food-type {
      margin-top: 4%;
    }
    .food-type p {
      font-size: 1.6rem;
    }
    .img-bg img {
      width: 90%;
    }
    .answer img {
      width: 32%;
    }
    .answer .yes {
      left: 15%;
    }
    .answer .no {
      right: 15%;
    }
    .back {
       bottom: 3%;
    }
  }

  @media screen and (min-width:400px) and (max-height: 736px) { 
    .food-type {
      margin-top: 5%;
    }
    .img-bg img {
      width: 90%;
    }
    .back {
       bottom: 3%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/RecordMeals.vue